import * as React from 'react';
import { cn } from '@/lib/utils';

const MyProgress = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex flex-col', className)}
    {...props}
  />
));
MyProgress.displayName = 'MyProgress';

const MyProgressHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex items-center justify-between gap-4', className)}
    {...props}
  />
));
MyProgressHeader.displayName = 'MyProgressHeader';

const MyProgressTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn('mb-0 text-sm font-light text-neutral-darker', className)}
    {...props}
  />
));
MyProgressTitle.displayName = 'MyProgressTitle';

export { MyProgress, MyProgressHeader, MyProgressTitle };
